export default __webpack_public_path__ + "static/media/ba-logo.7cb938c9.png";